import React from 'react';
import { useTranslation } from "react-i18next";
interface Props {
  dashboardUsage?: boolean;
}

const PaymentHeader = ({ dashboardUsage }: Props) => {
  // translations
  const tLabels = useTranslation("payments\\payments").t;

  return (
    <div className={`d-none d-sm-flex row no-gutters text-muted font-weight-bold mr-5 ${dashboardUsage ? "mb-1" : "px-3 mb-2"}`}>
      <div className="col-1"></div>
      <div className="col-3 pl-2">
        <span>{tLabels("paymentHeader.paymentDetail")}</span>
      </div>
      <div className="col-3 pl-3">
          <span>{tLabels("paymentHeader.amount")}</span>
          <span className="d-none d-lg-inline">{tLabels("paymentHeader.used")}</span>
      </div>
      <div className="col-5 pl-2 pl-xl-4">
        <span>{tLabels("paymentHeader.usedFor")}</span>
      </div>
    </div>
  )
}

export default PaymentHeader;
